/* SOUHLAS KLIENTA — záznam odpovědi „Ano / Později / Ne“.
 * ============================================================================
 *
 * Tvar hodnoty: { odpoved: "ano" | "pozdeji" | "ne", kdy: ISO řetězec, poznamka }
 * Bez odpovědi je hodnota `null` — NE prázdný objekt a NE „ne“. Nezadané není
 * odmítnutí, stejně jako nezadané číslo není nula.
 *
 * PROČ TŘI ROVNOCENNÉ VOLBY
 * -------------------------
 * „Ne“ je platná odpověď a nástroj ji respektuje — zapíše ji stejně jako „Ano“.
 * Žádná volba není předvybraná, žádná není výraznější (nátlak přes vzhled je
 * pořád nátlak, § 5b z. 634/1992). „Později“ je samostatná odpověď, ne
 * zamaskované „ne“ ani „ano“.
 */

export const ODPOVEDI = Object.freeze(["ano", "pozdeji", "ne"]);

/** Nejdelší poznámka. Je to krátká poznámka k odpovědi, ne zápis ze schůzky. */
export const MAX_POZNAMKA = 280;

const jeOdpoved = (o) => ODPOVEDI.includes(o);

/** Prázdná poznámka je `null` (nezadáno), ne prázdný řetězec. Text se při
 *  psaní NEOŘEZÁVÁ — jinak by poradce nemohl napsat mezeru na konci slova. */
export function poznamkaNeboNull(text) {
  if (text == null) return null;
  const s = String(text).slice(0, MAX_POZNAMKA);
  return s.trim() === "" ? null : s;
}

/**
 * Nový záznam po kliknutí na odpověď. Poznámka z předchozího záznamu zůstává
 * (poradce si rozmyslel volbu, ne poznámku). Čas je čas ODPOVĚDI.
 * @returns {{odpoved: string, kdy: string, poznamka: (string|null)} | null}
 */
export function zaznamOdpovedi(odpoved, predchozi = null, ted = new Date()) {
  if (!jeOdpoved(odpoved)) return null;
  const cas = ted instanceof Date && !Number.isNaN(ted.getTime()) ? ted : new Date();
  return {
    odpoved,
    kdy: cas.toISOString(),
    poznamka: poznamkaNeboNull(predchozi && predchozi.poznamka),
  };
}

/** Změna poznámky u existující odpovědi. Bez odpovědi se poznámka nezapisuje
 *  (hodnota zůstává `null`) — poznámka patří k odpovědi, ne sama o sobě. */
export function sPoznamkou(hodnota, text) {
  const h = normalizujSouhlas(hodnota);
  if (!h) return null;
  return { ...h, poznamka: poznamkaNeboNull(text) };
}

/** Byla odpověď dána? (Jakákoli, i „ne“.) Hodí se jako brána kroku. */
export function jeZodpovezeno(hodnota) {
  return !!hodnota && jeOdpoved(hodnota.odpoved);
}

/** Uložená hodnota z databáze / autosave → platný záznam nebo `null`.
 *  Neplatné datum se nevymýšlí: `kdy` pak zůstane `null`. */
export function normalizujSouhlas(hodnota) {
  if (!hodnota || typeof hodnota !== "object" || !jeOdpoved(hodnota.odpoved)) return null;
  const d = hodnota.kdy ? new Date(hodnota.kdy) : null;
  return {
    odpoved: hodnota.odpoved,
    kdy: d && !Number.isNaN(d.getTime()) ? d.toISOString() : null,
    poznamka: poznamkaNeboNull(hodnota.poznamka),
  };
}
